
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart, FileText, Wrench, Search, Shield, Building2, Mail, PenLine, Gauge } from 'lucide-react';
import { useMobileMenu } from './MobileMenuContext';

const MobileAdminMenuItems = () => {
  const navigate = useNavigate();
  const { closeMenu, isAdmin } = useMobileMenu();

  const handleNavigation = (path: string) => {
    navigate(path);
    closeMenu();
  };

  const adminMenuItems = [
    { icon: BarChart, label: 'Analytics', path: '/admin/analytics' },
    { icon: FileText, label: 'Content Dashboard', path: '/admin/content' },
    { icon: Search, label: 'Search Indexing', path: '/admin/search-indexing' },
    { icon: Building2, label: 'Institutional', path: '/admin/institutional' },
    { icon: Mail, label: 'Email', path: '/admin/emails' },
    { icon: Shield, label: 'Rechtsdokumente', path: '/admin/legal' },
    { icon: PenLine, label: 'Writer (beta)', path: '/write' },
    { icon: Gauge, label: 'Writer Telemetry', path: '/admin/writer-telemetry' },
    { icon: Wrench, label: 'Storage Diagnostics', path: '/dev/storage-diagnostics' },
    { icon: Wrench, label: 'Storage Documentation', path: '/dev/storage-documentation' },
  ];

  if (!isAdmin) return null;

  return (
    <div>
      <h3 className="text-sm font-semibold text-muted-foreground mb-3 uppercase tracking-wider">
        Admin Tools
      </h3>
      <div className="space-y-1">
        {adminMenuItems.map((item, index) => (
          <button
            key={`${item.path}-${index}`}
            onClick={() => handleNavigation(item.path)}
            className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-muted/50 transition-colors"
          >
            <item.icon className="h-5 w-5 text-muted-foreground" />
            <span className="font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileAdminMenuItems;
